import React, { useState, useEffect} from "react";

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}

function AccountPage(){
    const apiKey = process.env.REACT_APP_API_KEY;
    const windowSize = useWindowSize();
    const [userData, setUserData] = useState(null)
    const [userShippingStreet, setUserShippingStreet] = useState(null)
    const [userShippingZipCode, setUserShippingZipCode] = useState(null)
    const [userShippingCity, setUserShippingCity] = useState(null)
    const [userShippingState, setUserShippingState] = useState(null)
    const [userShippingApt, setUserShippingApt] = useState(null)
    const [AllProductsInformation, setAllProductsInformation] = useState([]);
    const [productImages, setProductImages] = useState({});
    const [userOrders, setUserOrders] = useState()

    useEffect(() => {
        const userDataFromStorage = localStorage.getItem("userData");
        if (!userDataFromStorage){
            window.location.replace("/")
        }
        if (!userDataFromStorage) return;
        
        //console.log(userDataFromStorage)
        const parsedData = JSON.parse(userDataFromStorage);
        // console.log(parsedData)
        // if(!parsedData){
        //     window.location.replace("/")
        // }
        setUserData(parsedData)
        setUserShippingStreet(parsedData.ShippingAddressStreet)
        setUserShippingCity(parsedData.ShippingAddressCity)
        setUserShippingZipCode(parsedData.ShippingAddressZipCode)
        setUserShippingState(parsedData.ShippingAddressState)
        setUserShippingApt(parsedData.ShippingAddressApt)
      
    }, []);

    useEffect(() => {
        if(userData && userData.admin == 1){
            fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/allProductsInformation`)
            .then(res => res.json())
            .then(data => {
            setAllProductsInformation(data);
            //console.log("all Profucts ", data)
            fetchAllProductImages(data);
            HandleGetUserOrders();
            })
            .catch(err => console.error(err));
        }
    }, [userData]);

    const HandleGetUserOrders = async () => {
        try {
            const userDataFromStorage = localStorage.getItem("userData");
            if (!userDataFromStorage) return;
            
            const parsedData = JSON.parse(userDataFromStorage);
            const email = parsedData.email;
            if (!email) return;

            // Step 1: Get all user orders
            const ordersRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/get-user-orders`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
         },
            body: JSON.stringify({api_key: apiKey, email: email })
            });

            if (!ordersRes.ok) throw new Error(`HTTP error! status: ${ordersRes.status}`);
            
            const ordersData = await ordersRes.json();
            console.log('User orders:', ordersData.orders);

            if (!ordersData.orders || ordersData.orders.length === 0) {
            console.log('No orders found for this user');
            setUserOrders([]);
            return;
            }

            // Step 2: Get order details for each UserOrder
            const ordersWithDetails = await Promise.all(
            ordersData.orders.map(async (userOrder) => {
                const orderIds = JSON.parse(userOrder.OrderIds);

                const detailsRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/get-user-orders-details`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ api_key: apiKey, orderIds: orderIds })
                });

                if (!detailsRes.ok) throw new Error(`HTTP error! status: ${detailsRes.status}`);
                
                const detailsData = await detailsRes.json();
                console.log('Order details:', detailsData.orders);

                return {
                uoid: userOrder.uoid,
                uemail: userOrder.uemail,
                OrderNumber: userOrder.OrderNumber,
                OrderDate: userOrder.OrderDate,
                status: userOrder.status,
                TrackingNumber: userOrder.TrackingNumber,
                items: detailsData.orders
                };
            })
            );

            console.log('Orders with details:', ordersWithDetails);
            setUserOrders(ordersWithDetails);

        } catch (error) {
            console.error('Error fetching user orders:', error);
        }
    }

    const fetchAllProductImages = async (products) => {
        const imagesData = {};

        await Promise.all(
            products.map(async (product) => {
            try {
                const url = `${process.env.REACT_APP_API_BASE_URL}api/users/product-images/${product.pid}`;
                //console.log("Fetching from:", url);
                
                const response = await fetch(url);
                
                if (response.ok) {
                const imageUrls = await response.json();
                //console.log(`Received URLs for product ${product.pid}:`, imageUrls);
                imagesData[product.pid] = imageUrls;
                }
            } catch (error) {
                console.error("Fetch error:", error);
                imagesData[product.pid] = [];
            }
            })
        );
        
        //console.log('All product images data:', imagesData);
        setProductImages(imagesData);
    };
    
    
    function HandleAddPhotos(productID){
        const productWithImages = {
            ...productID,
            productID: productID 
            ? JSON.stringify(productID) 
            : '[]'
        };
    
        const queryString = new URLSearchParams(productWithImages).toString();
        // console.log(queryString)
        // console.log(`/ProductImageUpload?${queryString}`)
        // window.location.href = `/ProductImageUpload?${queryString}`;
        window.location.replace(`/ProductImageUpload?${queryString}`);
    }

    async function HandleAddressChange(){
        if((userShippingStreet.length > 4) && (userShippingCity.length > 2) && (userShippingState.length > 1) && (userShippingZipCode.length > 2)){
            if((!(userShippingStreet === userData.ShippingAddressStreet)) || (!(userShippingApt === userData.ShippingAddressApt)) || (!(userShippingCity === userData.ShippingAddressCity)) || (!(userShippingState === userData.ShippingAddressState)) || (!(userShippingZipCode === userData.ShippingAddressZipCode))){
                const payload = {
                    api_key: apiKey, 
                    user_id: userData.id, 
                    street: userShippingStreet,
                     apt: userShippingApt, 
                     city: userShippingCity , 
                     state: userShippingState, 
                     zipcode: userShippingZipCode
                    };

                try {
                    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/changeAddress`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ api_key: apiKey, ...payload }),
                    });

                    if (!response.ok) throw new Error(`Error: ${response.statusText}`);

                    const userDataToStore = {
                        id: userData.id,
                        email: userData.email,
                        firstName: userData.firstName,
                        lastName: userData.lastName,
                        admin: userData.admin,
                        ShippingAddressStreet: userShippingStreet,
                        ShippingAddressApt: userShippingApt,
                        ShippingAddressCity: userShippingCity,
                        ShippingAddressState: userShippingState,
                        ShippingAddressZipCode: userShippingZipCode
                    };
                    //console.log(userDataToStore)
                    localStorage.setItem('userData', JSON.stringify(userDataToStore));
                    alert("Address Changed Successfully!")

                } catch (error) {
                    console.error("Failed to find user:", error);
                    return false;
                }
            }
        }
    }
    return(
        <div>
            <div className="AccountPageContainer" align="center">
                {userData ? 
                <p style={{fontSize: "24px",
                fontWeight: "bold",
                color: "#333333",
                textAlign: "center",
                marginBottom: "1px",
                }}> 
                    {userData.firstName} {userData.lastName}
                </p> : 
                    <p>Account Page</p>
                    
                }
                
                <p style={{fontSize: "20px",
                fontWeight: "bold",
                color: "#333333",
                textAlign: "left",
                marginBottom: "1px",
                }}>
                    Account
                </p>
                <div className="UserAccountInfo" style={{ marginLeft: "20px", display: 'flex', flexDirection: 'column'}}>
                    {userData ? 
                    <p style={{fontSize: "18px",
                    fontWeight: "bold",
                    color: "#333333",
                    textAlign: "left",
                    marginBottom: "1px",
                    }}> 
                        {userData.email} <br/>
                        {userData.ShippingAddressStreet ? 
                        <input
                            placeholder={userShippingStreet}
                            value={userShippingStreet}
                            onChange={(e) => setUserShippingStreet(e.target.value)}
                            required
                            style={{
                                width: '41%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                fontSize: "16px"
                            }}
                        />
                        
                            // ` ${userData.ShippingAddressStreet}`
                        
                    : " "
                    }
                    <br/>
                    {userData.ShippingAddressApt ?
                    
                    <input
                            placeholder={userShippingApt}
                            value={userShippingApt}
                            onChange={(e) => setUserShippingApt(e.target.value)}
                            style={{
                                width: '41%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                fontSize: "16px"
                            }}
                        />
                    // ` ${userData.ShippingAddressApt}`
                    : " "
                    }

                    {userData.ShippingAddressStreet ? 
                    <input
                            placeholder={userShippingCity}
                            value={userShippingCity}
                            onChange={(e) => setUserShippingCity(e.target.value)}
                            required
                            style={{
                                width: '41%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                fontSize: "16px"
                            }}
                        />
                        
                            // ` ${userData.ShippingAddressCity} ${userData.ShippingAddressState} ${userData.ShippingAddressZipCode}`
                        
                    : " "
                    }
                    <br/>
                    {userData.ShippingAddressStreet ? 
                    <input
                            placeholder={userShippingState}
                            value={userShippingState}
                            onChange={(e) => setUserShippingState(e.target.value)}
                            required
                            style={{
                                width: '25%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                fontSize: "16px",
                                marginRight: "10px"
                            }}
                        />
                        
                            // ` ${userData.ShippingAddressCity} ${userData.ShippingAddressState} ${userData.ShippingAddressZipCode}`
                        
                    : " "
                    }

                    {userData.ShippingAddressStreet ? 
                    <input
                            placeholder={userShippingZipCode}
                            value={userShippingZipCode}
                            onChange={(e) => setUserShippingZipCode(e.target.value)}
                            required
                            style={{
                                width: '10%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                fontSize: "16px"
                            }}
                        />
                        
                            // ` ${userData.ShippingAddressCity} ${userData.ShippingAddressState} ${userData.ShippingAddressZipCode}`
                        
                    : " "
                    }
                    <br/>
                    <button className="ChangeAddresssubmitbutton" style={{
                                width: '44%',
                                padding: "10px",
                                marginTop: "8px",
                                marginBottom: "15px",
                                border: "1px solid #84b385",
                                background: "#84b385",
                                borderRadius: "8px",
                                fontSize: "19px",
                                cursor: "pointer",
                                color: "#000000ff"
                            }}
                             type="button" onClick={() => HandleAddressChange}>submit</button>
                    
                    </p> : 
                        <p>Account Email</p>
                        
                    }
                    
                </div>
                {/* Will set show users orders, setup after setup payment processing and user can set up orders*/}
                {(userOrders) &&
                    <p style={{fontSize: "20px",
                    fontWeight: "bold",
                    color: "#333333",
                    textAlign: "left",
                    marginBottom: "1px",
                    }}>
                        Orders
                    </p>
                }
                {(!userOrders || userOrders.length === 0) &&
                    <div style={{
                        background: "rgba(166, 158, 158, 0.9)",
                        borderRadius: 20,
                        width: "90%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        paddingTop: 30,
                        paddingBottom: 30,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>
                        <p style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#333333",
                        marginBottom: "8px",
                        }}>
                        No Orders Yet
                        </p>
                        <p style={{
                        fontSize: "14px",
                        color: "#555555",
                        }}>
                        When you place an order, it will appear here
                        </p>
                    </div>
                    }
                <div>
                {userOrders && userOrders.map(order => (
                    <div key={order.uoid}>
                        <p style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#333333",
                        marginBottom: "3px",
                        }}>
                        Order #{order.OrderNumber}
                        </p>
                        <p style={{ color: "#333333", marginBottom: "3px" }}>
                        Date: {new Date(order.OrderDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })}
                        </p>
                        <p style={{ color: "#333333", marginBottom: "3px" }}>Status: {order.status}</p>
                        {/* {verticalSpacer(10)} */}

                        {order.items && order.items.map(item => {
                            const product = AllProductsInformation.find(p => p.pid === item.pid);
                            const productImage = productImages[item.pid]?.[0]; // Get first image using pid as key

                            return (
                                <div key={item.oid}
                                style={{
                                    background: "rgba(166, 158, 158, 0.9)",
                                    borderRadius: 20,
                                    width: "90%",
                                    height: 100,
                                    paddingTop: 10,
                                    paddingLeft: 20,
                                    paddingBottom: 100,
                                    alignItems: "left",
                                    marginBottom: '4%',
                                    display: 'flex',
                                    flexDirection: 'row',
                                }}>

                                {/* Product Image */}
                                {productImage && (
                                   <img
                                    style={{
                                        width: "auto",
                                        height: 50,
                                        objectFit: 'cover',
                                        borderRadius: "10px",
                                        marginRight: "20px", // Use marginRight instead of margin auto and marginLeft
                                    }}
                                    src={productImage}
                                    alt={product?.pname}
                                    onError={(e) => {
                                        console.error("Image failed to load:", productImage);
                                        e.target.style.display = 'none';
                                    }}
                                    />
                                )}


                                {/* Product Info */}
                                <div style={{
                                    height: "100%",
                                    paddingBottom: "3%",
                                    display: "flex",
                                    flexDirection: "column",
                                }}>
                                    <p>{product ? product.pname : 'Unknown Product'}</p>
                                    <p>Size: {item.size}</p>
                                    <p>Quantity: {item.count}</p>
                                    <p>${product ? product.price : 'N/A'}</p>
                                </div>

                                </div>
                            );
                        })}
                        {verticalSpacer(20)}
                    </div>
                ))}
                </div>

                {userData && userData.admin === 1 ? 
                    <p style={{fontSize: "20px",
                    fontWeight: "bold",
                    color: "#333333",
                    textAlign: "left",
                    marginBottom: "1px",
                    }}>
                        Products
                    </p>
                : " "}

                {userData && userData.admin === 1 ? 
                    <div style={{
                        alignItems: "left"
                    }}>
                        {AllProductsInformation.map(product => (
                            <div
                            key={product.pid}
                            className="AminProductsContainer"
                            style={{
                                background: "rgba(166, 158, 158, 0.9)",
                                borderRadius: 20,
                                width: "90%",
                                height: 20,
                                paddingTop: 10,
                                paddingLeft: 20,
                                paddingBottom: 50,
                                alignItems: "left",
                                marginBottom: '2%',
                                display: 'flex', flexDirection: 'row'

                            }}
                            // onClick={()=>handleProductClick(product)}
                            >
                                {product.pname} <br/>
                                {product.size} <br/>
                                ${Number(product.price).toFixed(2)}
                            {/* Display image from API */}
                            {productImages[product.pid] && productImages[product.pid].length > 0 ? (
                                <img
                                style={{
                                    width: "auto",
                                    height: 50,
                                    objectFit: 'cover',
                                    display: "block",
                                    margin: "0 auto",
                                    marginLeft: "5%",
                                    borderRadius: "10px",
                                }}
                                src={productImages[product.pid][0]} // Already a complete URL
                                alt={product.pname}
                                onError={(e) => {
                                    console.error("Image failed to load:", productImages[product.pid][0]);
                                    e.target.style.display = 'none';
                                }}
                                />
                            ) : (
                                // No image available
                                <div style={{
                                    width: "auto",
                                    height: 50,
                                    objectFit: 'cover',
                                    display: "block",
                                    margin: "0 auto",
                                    borderRadius: "10px",
                                }}>
                                No Image Available
                                </div>
                            )}

                            <button className="ChangeAddresssubmitbutton" style={{
                                width: '15%',
                                marginRight: "2%",
                                border: "1px solid #af7f26",
                                background: "#96703b",
                                borderRadius: "10px",
                                fontSize: "15px",
                                cursor: "pointer",
                                alignContent: "center",
                                paddingBottom: "3%",
                                color: "#000000ff"

                            }}
                             type="button" onClick={() => HandleAddPhotos(product.pid)}>Add Photos</button>
                            
                            </div>
                        ))}
                    </div>
                : " "}

                {userData && userData.admin === 1 ? 
                    <div>

                        <button className="ChangeAddresssubmitbutton" style={{
                                width: '25%',
                                marginRight: "5%",
                                border: "1px solid #509319",
                                background: "#1ea519",
                                borderRadius: "10px",
                                fontSize: "15px",
                                cursor: "pointer",
                                fontWeight: 600,
                                alignContent: "center",
                                padding: "1%",
                                color: "#000000ff"
                            }}
                             type="button" onClick={() =>  window.location.replace(`/AddProductPage`)}>Add Product</button>

                        <button className="ChangeAddresssubmitbutton" style={{
                                width: '25%',
                                marginRight: "5%",
                                border: "1px solid #96703b",
                                background: "#a37735",
                                borderRadius: "10px",
                                fontSize: "15px",
                                cursor: "pointer",
                                fontWeight: 600,
                                alignContent: "center",
                                padding: "1%",
                                color: "#000000ff"
                            }}
                             type="button" onClick={() =>  window.location.replace(`/ProductImageUpload`)}>Upload Product Images</button>
                            
                    </div>
                : " "}

                {verticalSpacer(30)}
                <button
                style={{
                    padding: "8px 16px",
                    width: "80%",
                    height: "35px",
                    borderRadius: 6,
                    border: "1px solid #333",
                    background: userData ? "#862222ff" : "transparent",
                    cursor: "pointer",
                    marginRight: 8,
                    color: "#000000ff",
                    fontWeight: "bolder",
                }}
                onMouseEnter={(e) =>
                    (e.currentTarget.style.background = userData ? "#992828ff" : "#f0f0f0")
                }
                onMouseLeave={(e) => (e.currentTarget.style.background = userData ? "#862222ff" :"none")}
                onClick={() => {
                    localStorage.removeItem('userData');
                    window.location.href = '/';
                    }
                }
                >
              Logout
            </button>







                
                
            </div>
            {verticalSpacer((windowSize.width * 0.5) + (windowSize.height * 0.8))}
        </div>
    );
}
export default AccountPage;